import React, { useEffect } from "react";
import CommonLayout from "./CommonLayout";
import { NavLink } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "store";
import { getInOrder } from "actions/orderActions";
import EntryCard from "shared/EntryCard";
import { Order } from "types/interfaces";
import { useParams } from "react-router";

interface IProfile {
  //Saran enakanan pake status kayaknya kayak tokped jadi tiap pemesanan ada variabel status
  path: string;
  title: string;
  exact?: boolean;
  //status: string;
}

const penjualanDashboard: IProfile[] = [
  {
    path: "/vendor-entries",
    title: "Semua Pesanan",
    exact: true,
  },
  {
    path: "/vendor-entries/new",
    title: "Pesanan Baru",
  },
  {
    path: "/vendor-entries/ready",
    title: "Siap Dikirim",
  },
  {
    path: "/vendor-entries/delivered",
    title: "Dalam Pengiriman",
  },
  {
    path: "/vendor-entries/finished",
    title: "Pesanan Selesai",
  },
  {
    path: "/vendor-entries/canceled",
    title: "Dibatalkan",
  },
];

const VendorEntries = () => {
  const dispatch = useDispatch();
  const { orders } = useSelector((state: RootState) => state.inOrder);

  useEffect(() => {
    dispatch(getInOrder());
  }, []);

  const { path } = useParams<{ path?: string }>();

  return (
    <div>
      <CommonLayout>
        <div className="space-y-6 sm:space-y-8">
          {/* HEADING */}
          <h2 className="text-3xl font-semibold">Daftar Pesanan</h2>
          <div className="w-14 border-b border-neutral-200 dark:border-neutral-700"></div>

          <div className="flex space-x-8 md:space-x-14 overflow-x-auto hiddenScrollbar">
            {penjualanDashboard.map((item) => {
              return (
                <NavLink
                  key={item.path}
                  exact={item.exact}
                  activeClassName="!border-primary-500"
                  to={item.path && item.path}
                  className="block py-5 md:py-8 border-b-2 border-transparent flex-shrink-0"
                >
                  {item.title}
                </NavLink>
              );
            })}
          </div>

          {/*// TODO: Buat grafik untuk jumlah view, */}

          {typeof path == "undefined"
            ? orders &&
              orders.map((order: Order, index: number) => {
                return <EntryCard key={index} data={order} />;
              })
            : orders &&
              orders
                .filter((stat: { status: string }) => stat.status === path)
                .map((order: Order, index: number) => {
                  return <EntryCard key={index} data={order} />;
                })}
        </div>
      </CommonLayout>
    </div>
  );
};

export default VendorEntries;
